import { tv } from "../../variants/tv.js";
const baseAutocompleteItemVariants = tv({
    slots: {
        itemWrapperSlot: 'bg-neutral-1 data-[highlighted]:bg-primary-2 data-[selected]:bg-primary-3 flex h-16 cursor-pointer justify-between gap-2 rounded-lg border-2 border-transparent p-2 outline-none transition-colors data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
        leftNodeAndTextSlot: 'flex gap-2',
        leftNodeIconWrapperSlot: 'my-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-lg',
        textSlot: 'my-auto flex flex-col px-1',
        rightNodeSlot: 'my-auto'
    },
    variants: {
        isHighlightedWithKeyboard: {
            true: {
                itemWrapperSlot: 'border-primary-8 border-2'
            }
        },
        isIndented: {
            true: {
                leftNodeAndTextSlot: 'pl-6'
            }
        }
    },
    compoundVariants: [
        {
            class: {
                itemWrapperSlot: 'data-[highlighted]:data-[selected]:bg-primary-4'
            }
        }
    ],
    defaultVariants: {
        isHighlightedWithKeyboard: false,
        isIndented: false
    }
});
export { baseAutocompleteItemVariants };
